import { Theme } from "@material-ui/core";
import { grisClair } from "../../theme";

const styles = (theme: Theme) =>
({
  title: {
    "& h2": {
      paddingTop: 16,
      paddingBottom:16,
    }
  },
    container: {
      display: "flex",
      alignItems: "flex-start",
      "& > div": {
        flex: 1,
      },
    },
    illu: {
      width: 300,
    },
    titleDepannage: {
      display: "flex",
      alignItems: "center",
      marginBottom: 24,
      "& h4": {
        marginBottom: 0,
      },
    },
    telephone: {
      display: "flex",
      alignItems: "center",
      fotnSize: 14,
      borderRadius: 12,
      padding: "0 12px",
      marginLeft: 24,
      textDecoration: "none",
      color: theme.palette.secondary.main,
    border: '1px solid ' + theme.palette.secondary.main,
      "& > svg": {
        marginLeft: -1,
        marginRight: 4,
      },
    },
    mapContainer: {
      height: 300,
    },
    mapBase: {
      height: 300,
      backgroundColor: "#abd3df",
    },
    // INPUT
    formControl: {
      width: 310,
      paddingRight: 12,
      position: "relative",
      display: "flex",
      "& .MuiOutlinedInput-input": {
        paddingRight: "32px",
      },
      "&:hover": {
        "& $clearIcon": {
          opacity: "1",
        },
      },
      "& .MuiInputAdornment-root": {
        "& > button": {
          "&:hover": {
            background: "none",
            "& svg": {
              "& g": {
                fill: theme.palette.secondary.main,
              },
            },
          },
        },
      },
    },
    input: {
      borderRadius: 4,
      padding: "3px 0 3px 12px",
      fontSize: 12,
      color: "black",
      border: "0.2px solid rgba(92,92,92,0.3)",
      background: grisClair,
      "&:before, &:after": {
        borderBottom: "none !important",
      },
      "&:hover": {
        "&:before": {
          borderBottom: "none !important",
        },
        "& $clearIcon": {
          opacity: "1",
        },
      },
    },
    focused: {
      borderColor: "#5C5C5C",
    },
    label: {
      fontSize: 13,
      transform: "scale(1)",
      color: "black",
      lineHeight: 1.3,
    },
    "@media all and (max-width: 1400px)": {
      container: {
        display: "block",
      },
      illuHome: {
        display: "none",
      },
    },
    "@media all and (max-width: 430px)": {
      titleDepannage: {
        alignItems: "flex-start",
        flexDirection: "column",
      },
      telephone: {
        marginLeft: 0,
        marginTop: 12,
      },
    },
  } as any);

export default styles;
